import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/terms.scss";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <main className="policy-page terms">
      <header className="policy-hero policy-hero--legal">
        <p className="policy-eyebrow">Legal</p>
        <h1>Terms of use</h1>
        <p>
          The terms that apply when browsing and shopping with {siteConfig.brandName}.
        </p>
        <span>Last updated 13 August 2026</span>
      </header>

      <div className="policy-layout">
        <nav className="policy-nav" aria-label="Legal pages">
          <p>Legal information</p>
          <Link to="/privacy" onClick={toTop}>
            Privacy notice <span aria-hidden="true">→</span>
          </Link>
          <Link className="is-active" to="/terms" aria-current="page">
            Terms of use <span aria-hidden="true">→</span>
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact us <span aria-hidden="true">→</span>
          </Link>
        </nav>

        <article className="policy-content policy-content--legal">
          <section className="policy-intro" aria-labelledby="terms-overview">
            <p className="policy-eyebrow">Welcome</p>
            <h2 id="terms-overview">A clear, respectful storefront experience.</h2>
            <p>
              By browsing this store, you agree to use it lawfully and
              in a way that does not interfere with other visitors or the
              service. If you do not accept these terms, please stop using
              the site.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-demo">
            <div className="policy-section__heading">
              <span>01</span>
              <h2 id="terms-demo">Orders and acceptance</h2>
            </div>
            <p>
              An order is an offer to purchase. We may accept or decline it due
              to availability, payment verification, pricing errors, delivery
              restrictions, or suspected misuse. An order is accepted when we
              send confirmation that it has entered fulfilment.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-use">
            <div className="policy-section__heading">
              <span>02</span>
              <h2 id="terms-use">Permitted use</h2>
            </div>
            <p>
              You may browse the site and use its shopping features for personal,
              lawful purposes. You may not
              attempt to disrupt, probe, reverse engineer, automate abusive
              traffic, introduce malicious code, misrepresent an affiliation, or
              use the interface to violate another person’s rights.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-content">
            <div className="policy-section__heading">
              <span>03</span>
              <h2 id="terms-content">Content &amp; intellectual property</h2>
            </div>
            <p>
              The store’s interface, copy, product concepts, graphics,
              and code presentation are protected by applicable rights. A visit
              does not transfer ownership or grant permission to reproduce,
              publish, sell, or create misleading derivatives of that material.
              Third-party technical names remain the property of their owners.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-accuracy">
            <div className="policy-section__heading">
              <span>04</span>
              <h2 id="terms-accuracy">Availability &amp; accuracy</h2>
            </div>
            <p>
              We aim for a polished and reliable preview, but the site may be
              changed, paused, or withdrawn without notice. Information may
              contain errors or become outdated. In a live store, material order
              corrections would be communicated before fulfilment wherever
              reasonably possible.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-links">
            <div className="policy-section__heading">
              <span>05</span>
              <h2 id="terms-links">Links &amp; third-party services</h2>
            </div>
            <p>
              External links may be provided for convenience. Their content,
              availability, and privacy practices are controlled by their
              operators. A link does not imply endorsement, and you should review
              the terms that apply to any external service you choose to use.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-liability">
            <div className="policy-section__heading">
              <span>06</span>
              <h2 id="terms-liability">Disclaimers &amp; responsibility</h2>
            </div>
            <p>
              The service is provided on an “as available” basis to the
              fullest extent permitted by law. Nothing here excludes rights or
              responsibilities that cannot lawfully be excluded. For production,
              liability language and governing-law provisions must be reviewed
              by qualified counsel for the operating entity and its markets.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="terms-changes">
            <div className="policy-section__heading">
              <span>07</span>
              <h2 id="terms-changes">Changes &amp; contact</h2>
            </div>
            <p>
              These terms may evolve with the service. The updated date
              above indicates the latest revision. Questions about the
              store can be sent to {siteConfig.contact.email}.
            </p>
          </section>

          <section className="policy-help" aria-labelledby="terms-help">
            <div>
              <p className="policy-eyebrow">Need clarification?</p>
              <h2 id="terms-help">Start a conversation with our team.</h2>
            </div>
            <Link to="/contact" onClick={toTop}>
              Contact us <span aria-hidden="true">↗</span>
            </Link>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Terms;
